import VcCarousel from './src/vc-carousel'

VcCarousel.install = function (Vue) {
  Vue.component(VcCarousel.name, VcCarousel)
}

export default VcCarousel
